import { z } from 'zod';
export const subscriptionStatusSchema = z.enum([
    // Configured in the ops tool, but not yet shown to the partner.
    'Draft',
    // The partner has accepted the terms and left payment details, so a contract exists and Partner Management is
    // checking them out. Billing can only be initiated from here.
    'InValidation',
    // Validated, but the term has not started because the first payment has not been billed: either it is still ahead
    // of the agreed start date or it was attempted and not collected.
    'PendingActivation',
    'Active',
    // A renewal failed and the retry is running.
    'PastDue',
    // Retries are exhausted and the subscription is still unpaid.
    'Unpaid',
    // Terminated or cancelled.
    'Terminated',
]);
export const SubscriptionStatus = subscriptionStatusSchema.enum;
export const isLiveSubscriptionStatus = (status) => status !== SubscriptionStatus.Terminated;
